var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 174,
    viewBox: "0 0 174 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53 110V97C53 94.7909 54.7909 93 57 93H66C68.2091 93 70 94.7909 70 97V110C70 112.209 68.2091 114 66 114H57C54.7909 114 53 112.209 53 110Z",
    stroke: "black",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103 110V97C103 94.7909 104.791 93 107 93H116C118.209 93 120 94.7909 120 97V110C120 112.209 118.209 114 116 114H107C104.791 114 103 112.209 103 110Z",
    stroke: "black",
    strokeWidth: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103 74V61C103 58.7909 104.791 57 107 57H116C118.209 57 120 58.7909 120 61V74C120 76.2091 118.209 78 116 78H107C104.791 78 103 76.2091 103 74Z",
    stroke: "black",
    strokeWidth: 6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53 74V61C53 58.7909 54.7909 57 57 57H66C68.2091 57 70 58.7909 70 61V74C70 76.2091 68.2091 78 66 78H57C54.7909 78 53 76.2091 53 74Z",
    stroke: "black",
    strokeWidth: 6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103 38V26C103 23.7909 104.791 22 107 22H116C118.209 22 120 23.7909 120 26V38C120 40.2091 118.209 42 116 42H107C104.791 42 103 40.2091 103 38Z",
    stroke: "black",
    strokeWidth: 6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53 37V25C53 22.7909 54.7909 21 57 21H66C68.2091 21 70 22.7909 70 25V37C70 39.2091 68.2091 41 66 41H57C54.7909 41 53 39.2091 53 37Z",
    stroke: "black",
    strokeWidth: 6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M119 169H52C44.8203 169 39 163.18 39 156V19C39 11.8203 44.8203 6 52 6H119C126.18 6 132 11.8203 132 19V156C132 163.18 126.18 169 119 169Z",
    stroke: "black",
    strokeWidth: 6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70 168.5V124.98C70 124.534 70 124.311 70.0178 124.124C70.1985 122.212 71.712 120.698 73.6236 120.518C73.8114 120.5 74.0342 120.5 74.48 120.5H99.02C99.4658 120.5 99.6886 120.5 99.8764 120.518C101.788 120.698 103.302 122.212 103.482 124.124C103.5 124.311 103.5 124.534 103.5 124.98V168.5",
    stroke: "black",
    strokeWidth: 6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.0c2e05f290ea7b4a28aea140e676db26.svg";
export { ForwardRef as ReactComponent };